module.exports = __webpack_public_path__ + "img/htmlyjavascript.be90d2c6.png";